module.exports = __webpack_public_path__ + "static/media/ericSchwartz.9f166278.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/ericSchwartz.jpg
// module id = 1564
// module chunks = 1